import api from '@services/api';
import { NewPositionRestriction, PositionRestrictionResponse } from '../models/positionRestriction';

/**
 * <p>
 * API endpoints that cover all Position restriction related CRUD calls
 */

export const PositionRestrictionApi = api.injectEndpoints({
  endpoints: (builder) => ({
    searchPositionRestriction: builder.query<PositionRestrictionResponse[], string>({
      query: (input: string) => ({
        url: encodeURI(`/indirect/rule-position-restriction/searchBy?searchTerm=${input}`),
      }),
      providesTags: ['PositionRestriction'],
    }),
    createPositionRestriction: builder.mutation<void, NewPositionRestriction>({
      query: (input: NewPositionRestriction) => ({
        url: encodeURI(`/indirect/rule-position-restriction/create`),
        body: input,
        method: 'POST',
      }),
      invalidatesTags: ['PositionRestriction'],
    }),
    deletePositionRestriction: builder.mutation<void, number>({
      query: (input: number) => ({
        url: encodeURI(`/indirect/rule-position-restriction/delete?id=${input}`),
        method: 'DELETE',
      }),
      invalidatesTags: ['PositionRestriction'],
    }),
  }),
});

export const {
  useSearchPositionRestrictionQuery,
  useCreatePositionRestrictionMutation,
  useDeletePositionRestrictionMutation,
} = PositionRestrictionApi;
